import {
    HttpClient,
    HttpHeaders,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IMLPackage } from '@models';
import { ODataService } from '@services/generics/odata.service';
import { MapperService } from '@services/mapper.service';

@Injectable()
export class MLPackagesService extends ODataService<IMLPackage, string> {
    protected _endpoint = '/odata/MLPackages';
    private _contentType = 'application/x-zip-compressed';

    constructor(http: HttpClient) {
        super(http, MapperService.mlPackageMap);
    }

    public generateSignedUrlForModelUpload(fileName: string) {
        const payload = JSON.stringify({
            fileName: fileName,
            contentType: this._contentType,
        });
        return this._http.post(`${this._endpoint}/UiPath.Server.Configuration.OData.GenerateSignedUrlForMLPackageUpload`, payload);
    }

    public uploadModelToSignedUrl(file: File, signedUrl: string) {
        const req = new HttpRequest('PUT', signedUrl, file, {
            headers: new HttpHeaders({ 'Content-Type': this._contentType }),
            reportProgress: true,
        });
        return this._http.request(req);
    }

    public createPackage(data: IMLPackage, stagingUri: string) {
        const req = new HttpRequest(
            'POST',
            `${this._endpoint}/UiPath.Server.Configuration.OData.CreateMLPackage`,
            this._populatMetaData(data, stagingUri));
        return this._http.request(req);
    }

    public createPackageVersion(mlPackageId: string, data: IMLPackage, stagingUri: string) {
        const req = new HttpRequest(
            'POST',
            `/odata/MLPackageVersions('${mlPackageId}')/UiPath.Server.Configuration.OData.CreateMLPackageVersion`,
            this._populatMetaData(data, stagingUri));
        return this._http.request(req);
    }

    public checkUniqueMLPackageName(mlPackageName: string) {
        const endpoint = `/odata/MLPackages/UiPath.Server.Configuration.OData.CheckUniqueMLPackageName(mlPackageName='${mlPackageName}')`;

        return this._http.get(endpoint);
    }

    private _populatMetaData(data: IMLPackage, stagingUri: string): string {
        const metaData = {
            ChangeLog: data.modelVersions[0].changeLog,
            Description: data.description,
            InputDescription: data.modelVersions[0].inputDescription,
            InputType: data.inputType,
            MlPackageLanguage: data.modelVersions[0].modelLanguage,
            Name: data.name,
            DisplayName: data.name,
            OutputDescription: data.modelVersions[0].outputDescription,
            ProcessorType: data.modelVersions[0].processorType,
            StagingUri: stagingUri,
        };
        const payload = { metadata: metaData };
        return JSON.stringify(payload);
    }
}
